module.exports = __webpack_public_path__ + "static/media/ios-volume-mute.66e5ba21.svg";